import { createFileRoute } from "@tanstack/react-router";

import ToolApprovalAdmin from "@/components/ToolApprovalAdmin";

// Passthrough, like every admin route: the console component owns everything, and
// `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/tool-approval")({
  component: ToolApprovalAdmin,
});
